/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IAgentChipList } from '../../interfaces/IAgentChatInterface';

@Component({
    selector: 'nalco-agent-chip-list',
    templateUrl: './chip-list.component.html',
    styleUrls: ['./chip-list.component.scss'],
    standalone: false
})
export class ChipListComponent implements OnChanges {
  @Input() chipList: IAgentChipList[] = [];
  @Output() chipSelectionChangeEmitter = new EventEmitter<IAgentChipList>();
  /**
   * Handles changes to component input properties.
   * Updates the internal chipList property when the chipList input changes.
   * 
   * @param changes - Object containing the changed properties with their current and previous values
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.chipList?.currentValue) {
      // Handle changes to the chipList input if necessary
      this.chipList = changes.chipList.currentValue;
    }
  }

  /**
   * Handles the selection of a chip from the chip list.
   * 
   * @param chip - The chip that was selected by the user
   * @returns void
   * 
   * @emits chipSelectionChangeEmitter - Emits the selected chip data to parent components
   */
  public onChipSelection(chip: IAgentChipList): void {
    // Emit the selected chip or handle the selection logic
    this.chipSelectionChangeEmitter.emit(chip);
  }

  /**
   * Handles navigation selection by opening the specified link in a new browser tab.
   * 
   * @param navigationLink - The URL string to navigate to
   * @public
   */
  public onNavigationSelected(navigationLink: string) {
    if (navigationLink) {
      window.open(navigationLink, '_blank');
    }
  }
}
